import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";
// router setup
import routes from "./routes";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    // Notification Drawer Close when route change
    store.commit("SET_NOTIFY_DRAWER", false);
    //

    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = { from, next, to, router };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  } else {
    next({ name: "login" });
  }
  return next();
});

router.afterEach((to) => {
  if (window.clarityReady && window.clarity) {
    window.clarity("set", "page_name", to.name || to.path);

    const authUser = store.state.auth.user;
    if (authUser) {
      // .log(" router afterEach", authUser.tenant_id);
      window.clarity("identify", authUser.id.toString());
      window.clarity("set", "user_id", authUser.id.toString());
      window.clarity("set", "user_name", authUser.name);
      window.clarity("set", "user_email", authUser.email);
      window.clarity("set", "tenant", authUser?.tenant_id?.toString());
      window.clarity("set", "tenant_name", authUser?.tenant_name || "");
    }
  }
});

// ✅ ADD THIS BLOCK — Handles chunk 404 after new deployment
router.onError((error) => {
  const isChunkError =
    error.name === "ChunkLoadError" ||
    /loading chunk \d* failed/i.test(error.message) ||
    /Loading CSS chunk \d* failed/i.test(error.message);

  if (isChunkError) {
    const alreadyReloaded = sessionStorage.getItem("chunk_reload");

    if (!alreadyReloaded) {
      sessionStorage.setItem("chunk_reload", "true");
      window.location.reload(); // Auto reload with new chunks
    } else {
      // Avoid infinite reload loop
      sessionStorage.removeItem("chunk_reload");
      alert("App has been updated. Please refresh the page.");
    }
  }
});

export default router;
